// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment =
//{
//    production: false,
//    baseUrl: "https://localhost/api",
//    useMockData: true
//};
{
  production: false,
  // baseUrl:"https://cbo-gps-healthslice-api.azurewebsites.net/api/", 
  //baseUrl: "https://qa.intakeportal.healthperform.com/api/",
  baseUrl: "https://dev.odp.intakeportal.healthperform.com/api/",
  //baseUrl: "http://localhost:56430/api/",
  //baseUrl:"https://us-con-healthslice-api-dev.azurewebsites.net/api/",
  //baseUrl: "https://ussltccsw2454.solutions.glbsnet.com:9443/api/",
  // baseUrl:"https://ussltccsw2454.solutions.glbsnet.com:448/swagger/index.html",
  useMockData: false,
  surveyUrl: "http://localhost:4200/#/survey",
  environment: "default",

  authProvider: 'siteminder',

  // ,cognito: {
  //   userPoolId: 'us-east-2_0Ocel77gB',
  //   userPoolWebClientId: '7b7m95o4a7db4nn8lehauegffb',
  // }
  // ,cognito: {
  //   userPoolId: 'us-east-2_7QL1oX4XX',
  //   userPoolWebClientId: '3l31rmlv85288j8ku77o7s45o7',
  // }

  cognito: {
    userPoolId: 'us-gov-east-1_oDf77E2SC',
    userPoolWebClientId: '6ccc4k24prdv0aqpq81vd020mn',
  },

  tableauUrl: "",
  exportApiAccessKey: "TestAccessKey",
  REALTIME_SURVEY_EXPORT_ENABLED: true,
  PRE_POPULATED_QUESTION_RESPONSE_1: "Provider Legal Entity Name",
  PRE_POPULATED_QUESTION_RESPONSE_2: "Enter your agency's nine-digit Master Provider Index (MPI) Number",
  PRE_POPULATED_READONLY_QUESTION_1: "Enter your agency's nine-digit Master Provider Index (MPI) Number",
  PRE_POPULATED_READONLY_QUESTION_2: "",
  ImportURL: "https://localhost:58934/api/SurveyIntake/SaveSurveyIntake",
  ImportFilesURL: "https://localhost:58934/api/SurveyIntake/SaveSurveyIntakeFiles",

  consentNonSignPopUpHeaderHtmlContent: `<div>    
    <div style="font-size: 16px; margin-bottom: 10px;">
    <h6><strong>Instructions:</strong></h6>
      <p>All Supports Coordination Organizations (SCOs) that render Targeted Support Management services and/or Supports Coordination services through the Consolidated Waiver, Community Living Waiver, or Person/Family Directed Support Waiver must sign the below attestation.</p>

<p>The purpose of the attestation is to confirm that the SCO has met performance standards outlined in bulletin 00-25-03. The SCO designee completing this form must have knowledge of all information to which the SCO attests. The SCO designee should check all applicable boxes for which the SCO has documentation of meeting the criteria or will have documentation by January 1, 2026.</p>

<p>
  SCOs that fail to sign and submit this form by the end of the documentation submission period will receive a Directed Corrective Action Plan requiring completion of the attestation to remain qualified to provide Supports Coordination and/or Targeted Support Management services. Questions regarding this form should be sent to&nbsp;<a href="mailto:ra-pwodppbc@pa.gov">ra-pwodppbc@pa.gov</a>.
</p>

<p>As the Supports Coordination Organization designee of <<Provider Legal Name>> <<MPI Number>>, hereafter referred to as "SCO", I attest that the SCO has documentation that the SCO currently meets or will meet the criteria no later than January 1, 2026 for all boxes checked below: <br>
<hr>
<h6><strong><u>Standards for All Supports Coordination Organizations</u></strong></h6>
</p>
</div>
</div>`,

  consentNonSignPopUpHeaderHtmlContentForRS: `<div>    
    <div style="font-size: 16px; margin-bottom: 10px;">
    <h6><strong>Instructions:</strong></h6>
      <p>All providers of Residential Habilitation, Life Sharing, and/or Supported Living services funded through the Consolidated Waiver and/or Community Living Waiver must complete the below attestation.  The provider must complete a separate attestation for each Master Provider Index (MPI) number through which the provider renders Residential Habilitation, Life Sharing, and/or Supported Living services through the Consolidated Waiver or Community Living Waiver.</p>

<p>The purpose of the attestation is to confirm that the provider has met performance standards outlined in bulletin 00-24-01.  The attestation, in addition to documentation submitted by the provider, will help inform the Office of Developmental Programs' (ODP) assignment of a performance-based contracting tier for the provider.  The provider designee completing this form must have knowledge of all information to which the provider attests.  The provider designee should check all applicable boxes for the tier for which the provider has documentation of meeting the criteria or will have documentation by the date outlined in the criteria.</p>

<p>Questions regarding this form should be sent to <a href="mailto:ra-pwodppbc@pa.gov">ra-pwodppbc@pa.gov</a>.</p>

<p>As the provider designee of <<Provider Legal Name>> <<MPI Number>>, hereafter referred to as "Residential Provider", I attest that the Residential Provider can document that the Residential Provider meets the criteria for all boxes checked below for the tier requested by the Residential Provider:</p>
<hr>
</div>
</div>`,

  consentSignPopUpHeaderHtmlContent: `<div>    
    <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">
    <strong> By signing this document, I attest that I have knowledge of all the information checked on this form and all information checked is accurate and that the SCO will be able to produce documentation demonstrating the SCO meets the requirements for all items checked upon request by ODP.  Failure to produce requested documentation may result in a sanction outlined in 55 Pa. Code §6100.742. </strong> 
    </div>
  </div>`,

  consentSignPopUpHeaderHtmlContentForRS: `<div>    
    <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">
    <strong> By signing this document, I attest that I have knowledge of all the information checked on this form and all information checked is accurate and that the Residential Provider will be able to produce documentation demonstrating the Residential Provider meets the requirements for all items checked upon request by ODP. Failure to produce requested documentation may result in a change of performance-based contracting tier or other sanction outlined in 55 Pa. Code §6100.742. </strong> 
    </div>
  </div>`,

  disputeSignPopUpHeaderHtmlContent: `<div>    
    <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">
    <strong> I hereby attest that the information provided in this form and all supporting documentation is true and accurate to the best of my knowledge.  I understand that this is not an opportunity to submit new materials or modify previously submitted materials. </strong>
    </div>
  </div>`,

  consentSignPopUpHeaderHtmlContentDemo: `<div>    
    <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">
    <strong> By signing this document, I attest that I have knowledge of all the information checked on this form and all information checked is accurate and that the Provider will be able to produce documentation demonstrating the Provider meets the requirements for all items checked upon request by Health Perform.  Failure to produce requested documentation may result in a sanction outlined in 55 Pa. Code §6100.742. </strong> 
    </div>
  </div>`,

  //Siteminder Environment URL's
  siteminder: {
    authenticationUrl: 'https://www.hhslogin-dev.dhs.pa.gov/affwebservices/secure/secureredirect/odpintakedev',
    loginUrl: 'https://www.hhslogin-dev.dhs.pa.gov/affwebservices/CASSO/oidc/ODP_BP_Intake_Client/authorize',
    clientId: 'f10fccb7-55b2-4f64-828b-594aea17ff99',
    redirectUri: 'https://dev.odp.intakeportal.healthperform.com/odp/signin-oidc-bp',//redirectUri:'https://dummyurl.pa.lcl:4200/odp/signin-oidc-bp',
    logoutUrl: 'https://www.hhslogin-dev.dhs.pa.gov/affwebservices/public/odplogoutintakedev.jsp',
    postLogoutRedirectUri: 'https://dev.odp.intakeportal.healthperform.com/logged-out',
    issuer: 'https://www.hhslogin-dev.dhs.pa.gov/affwebservices/CASSO/oidc/ODP_BP_Intake_Client',
    tokenEndpoint: 'https://www.hhslogin-dev.dhs.pa.gov/affwebservices/CASSO/oidc/ODP_BP_Intake_Client/token',
    userinfoEndpoint: 'https://www.hhslogin-dev.dhs.pa.gov/affwebservices/CASSO/oidc/ODP_BP_Intake_Client/userinfo',
    revocationEndpoint: 'https://www.hhslogin-dev.dhs.pa.gov/affwebservices/CASSO/oidc/ODP_BP_Intake_Client/revoke'
  }
};